import { render, staticRenderFns } from "./branding.vue?vue&type=template&id=fc5a1ff4&"
import script from "./branding.vue?vue&type=script&lang=js&"
export * from "./branding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports